var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-16"},[_c('CenteredThin',[_c('h1',{staticClass:"text-4xl font-bold"},[_vm._v(" "+_vm._s(_vm.instruction.title)+" ")]),_c('RichTextDisplay',{staticClass:"my-8 prose",attrs:{"text":_vm.instruction.body}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }